<header class="header shadow">
  <nav class="navbar" [ngClass]="{'dev-theme': is_dev}">
    <div class="container-fluid">
      <div class="navbar-holder">
        <div class="row d-flex justify-content-center">
          <h1 class="h3 font-weight-bold my-2">Verificar Autenticidade</h1>
          <!-- Navbar Header-->
          <div class="navbar-header fixed-top position-absolute float-left my-2 ml-4">
            <!-- Toggle Button-->
            <img src="assets/images/logo_lccv_icon.png" class="img-fluid" width="40px" />
            <!-- Navbar Brand --><a href="" class="navbar-brand d-none d-sm-inline-block pt-2 px-2">
              <div class="brand-text d-none d-lg-inline-block"><strong>LCCV</strong></div>
              <div class="brand-text d-none d-sm-inline-block d-lg-none"><strong>LCCV</strong></div></a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>

<section class="container">
  <div class="row">
    <div class="col">
        <div *ngIf="err_msg"
            class="alert" [ngClass]="err_msg.alert_class">
            <span class="d-flex justify-content-center">{{err_msg.text}}</span>
        </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6">
      <form class="form-horizontal" [formGroup]="formValidar" (ngSubmit)="onSubmit(formValidar.value)">
        <ngx-spinner [fullScreen]="false" type="ball-clip-rotate-multiple" size="medium"></ngx-spinner>
        <div class="form-group row">
          <div class="col-12">
            <label >Tipo de documento</label>
            <select formControlName="id_tp_documento" class="form-control mb-3"  [ngClass]="{ 'is-invalid': id_tp_documento.invalid && (id_tp_documento.dirty || id_tp_documento.touched || submit_hover) }">
              <option disabled>Selecione o tipo de documento</option>
              <option *ngFor="let type of document_type_list" [ngValue]="type.id_tp_documento">
                {{ type.tp_documento }}
            </option>
            </select>
            <div class="invalid-feedback">
              Selecione um tipo de documento
            </div>
          </div>
          <div class="col-12">
            <label for="num_documento">Número do documento</label>
            <input type="number" formControlName="num_documento" class="form-control" id="num_documento" [ngClass]="{ 'is-invalid': num_documento.invalid && (num_documento.dirty || num_documento.touched || submit_hover) }">
            <div class="invalid-feedback">
            </div>
          </div>
          <div class="col-12">
            <label for="ano_documento">Ano do documento</label>
            <input type="text" formControlName="ano_documento" class="form-control" id="ano_documento" [ngClass]="{ 'is-invalid': ano_documento.invalid && (ano_documento.dirty || ano_documento.touched || submit_hover) }">
            <div class="invalid-feedback">
            </div>
          </div>
          <div class="col-12">
            <label for="cod_autenticidade">Código de autenticidade</label>
            <input type="text" formControlName="cod_autenticidade" class="form-control" id="cod_autenticidade" [ngClass]="{ 'is-invalid': cod_autenticidade.invalid && (cod_autenticidade.dirty || cod_autenticidade.touched || submit_hover) }">
            <div class="invalid-feedback">
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div class="form-group row">
          <div class="col-sm-6 offset-sm-3">
            <div class="row d-flex justify-content-center">
              <div #recaptcha [ngClass]="{'is-invalid': submit_hover && !(captchaStr)}"></div>
              <div class="invalid-feedback">
                Marque o captcha
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-row justify-content-center">
          <button type="button" class="btn btn-info mx-1" (click)="onClear()">Limpar</button>
          <button type="button" class="btn btn-primary mx-1"
            (click)="onSubmit(formValidar.value)"
            [disabled]="formValidar.invalid" (mouseover)="submit_hover=true">
            <span *ngIf="is_submit" class="spinner-border spinner-border-sm my-1" role="status" aria-hidden="true"></span>
            Verificar
          </button>
        </div>
      </form>
    </div>
    <div class="col-sm-6">
      <div class="card-header bg-light">
        <h5 class="card-title">Informações</h5>
      </div>
      <div class="card">
        <div class="card-body">
          <p class="card-text">
Este serviço se propõe a confirmar a validade dos documentos emitidos pelo Sistema de Informações do LCCV (Sumé).<br>
Para proceder com a validação informe os seguintes dados:<br>
- Tipo de documento;<br>
- Número do documento;<br>
- Ano do documento;<br>
- Código de autenticidade. <br>
Todos os dados podem ser encontrados no rodapé do documento.<br>
          </p>
        </div>
      </div>
    </div>
  </div>
  <version-modal class="float-right"></version-modal>
</section>
<!-- <button (click)="goTop()">top</button> -->
